export const files = {
  CURRICULUM: 'Curriculum',
  VIDEO: 'Video',
};
